// 成功提示的文案
export const successMessage = {
  certification: {
    title: '您的资质认证申请提交成功！',
    text: '我们将尽快为您审核'
  }
}
// 订单支付结果
export const orderPayList = {
  statusList: [
    {
      class: 'bg_top_linear-gradient bg_top_linear-blue',
      img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_success.png',
      typeImg: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_type_weixin.png',
      name: '支付成功', msg: '感谢您的购买', typeName: '微信支付', color: '#0767AB', btn1: '查看订单', btn2: '返回首页'
    },
    {
      class: 'bg_top_linear-gradient bg_top_linear-orange', // bg_top_linear-orange color: '#D1531C'
      img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_failed.png',
      typeImg: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_type_weixin.png',
      name: '支付失败', msg: '请尝试重新支付', typeName: '微信支付', color: '#0767AB', btn1: '重新支付', btn2: '转账支付'
    },
    {
      class: 'bg_top_linear-gradient bg_top_linear-blue', // bg_top_linear-yellow color: '#CB8552'
      img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_bank.png',
      typeImg: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_type_bank.png',
      name: '对公转账', msg: '请将款项汇入以下账户中', typeName: '对公转账', color: '#0767AB', btn1: '已转账付款', btn2: '复制转账信息'
    },
    {
      class: 'bg_top_linear-gradient bg_top_linear-green',
      img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_wait.png',
      typeImg: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_type_bank.png',
      name: '待确认中', msg: '付款正在确认中', typeName: '对公转账', color: '#40B44C', btn2: '复制转账信息'
    },
    {
      class: 'bg_top_linear-gradient bg_top_linear-blue', // bg_top_linear-orange color: '#D1531C'
      img: null,
      typeImg: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_type_weixin.png',
      name: '订单支付', msg: null, typeName: '微信支付', color: '#0767AB', btn1: '在线支付', btn2: '转账支付'
    },
    {
      class: 'bg_top_linear-gradient bg_top_linear-blue',
      img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_success.png',
      typeImg: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_type_zhifubao.png',
      name: '支付成功', msg: '感谢您的购买', typeName: '支付宝付款', color: '#0767AB', btn1: '查看订单', btn2: '返回首页'
    },
    {
      class: 'bg_top_linear-gradient bg_top_linear-orange', // bg_top_linear-orange color: '#D1531C'
      img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_failed.png',
      typeImg: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/pay_type_zhifubao.png',
      name: '支付失败', msg: '请尝试重新支付', typeName: '支付宝付款', color: '#0767AB', btn1: '重新支付', btn2: '转账支付'
    }
  ]
}
// 订单状态
export const orderPayStatus = {
  statusList: ['', '待支付', '待入账', '账期待审核', '账期待签约', '待出库', '已出库', '待收货', '账期待付款', '已完成', '逾期未付', '逾期已付', '已关闭', '退款中', '已支付待确认', '账期已付款待确认']
}

// vip svip 权益
export const vipAuth1 = [
  { title: '包邮政策', msg: '顺丰包邮', icon: '1' },
  { title: '专属客服', msg: '专享线上客服', icon: '2' }
]
export const vipAuth = [
  { title: '包邮政策', msg: '顺丰包邮', icon: '1' },
  { title: '专属客服', msg: '专享线上客服', icon: '2' },
  { title: '支付享', msg: '与优惠活动同享', icon: '3' }
]
// my order
export const userOrderCardList = [
  { img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/my/my_order_icon01.png', name: '待付款', id: 1 },
  { img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/my/my_order_icon02.png', name: '待发货', id: 2 },
  { img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/my/my_order_icon03.png', name: '待收货', id: 3 },
  { img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/my/my_order_icon04.png', name: '已完成', id: 4 }
  // { img: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/my/my_order_icon05.png', name: '售后', id: 100 }
]
export default {
  successMessage: successMessage,
  orderPayList: orderPayList,
  orderPayStatus: orderPayStatus,
  vipAuth1: vipAuth1,
  vipAuth: vipAuth
}
